import { useContext } from 'react';
import PropTypes from 'prop-types';
import { FiSend } from 'react-icons/fi';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import LoaderContext from '../../../../context/LoaderProvider';
import useToast from '../../../../hooks/useToast';
import { workReportLineStatus } from '../../../../utils/dataStatus';
import ConditionalWrapper from '../../../ConditionalWrapper/ConditionalWrapper';
import { LineToAPpprove } from '../../../../utils/globalPropTypes';
import { useDetailServiceRequest } from '../../../../context/DetailServiceRequestProvider';
import {
  getPerfilEjecuta,
  postLocationProgramPointService,
  rectifyLocationProgramPointService
} from '../../../../services/programPointsService';

const SendToApproveButton = (props) => {
  const { line, setChangeInLines, changeInLines, newFetch, setNewFetch, selectedDate, disabled } =
    props;

  const selectedDateFormated = new Date(line?.fecha || selectedDate);
  const today = new Date();
  const todayOlderThanSelectedDate = today < selectedDateFormated;
  const { setNewToast } = useToast();

  const { updateDetailsforAssignedStatus } = useDetailServiceRequest();

  const { setLoader } = useContext(LoaderContext);

  const fetchToRectifyALine = async () => {
    setLoader(true);
    try {
      const perfilEjecuta = getPerfilEjecuta();

      const body = {
        id: line.idParteDiario,
        cantidad: Number(line.cantidad),
        perfilEjecuta,
        puntosPrograma: []
      };

      const resp = await rectifyLocationProgramPointService(
        line.idParteDiario,
        body,
        perfilEjecuta
      );

      updateDetailsforAssignedStatus();

      setChangeInLines(!changeInLines);
      setNewFetch(!newFetch);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }
  };

  const fetchToApproveALine = async (lineToApprove) => {
    setLoader(true);
    try {
      const resp = await postLocationProgramPointService(lineToApprove);

      updateDetailsforAssignedStatus();
      setChangeInLines(!changeInLines);
      setNewFetch(!newFetch);
      setLoader(false);
      setNewToast({
        type: 'SUCCESS',
        message: resp.mensaje
      });
    } catch (error) {
      setLoader(false);
      setNewToast({
        type: 'ERROR',
        message: error?.data?.message || error?.mensaje
      });
    }
  };

  return (
    <ConditionalWrapper
      condition={todayOlderThanSelectedDate || line?.blockedBySap}
      wrapper={(children) => (
        <OverlayTrigger
          delay={{
            show: 250,
            hide: 400
          }}
          overlay={
            <Tooltip id="send-to-approve-request-detail">
              {line?.blockedBySap ? 'Inactiva por SAP' : 'Linea con fecha posterior a la actual'}
            </Tooltip>
          }
          placement="top"
        >
          {children}
        </OverlayTrigger>
      )}
    >
      <div className="p-1">
        <button
          aria-label="Enviar a aprobar"
          className="button_send_work_report"
          disabled={disabled || todayOlderThanSelectedDate}
          onClick={() => {
            if (line.estadoEnum === workReportLineStatus.enviar) {
              fetchToRectifyALine();
            } else {
              fetchToApproveALine([
                {
                  id: line.idParteDiario,
                  cantidad: Number(line.cantidad)
                }
              ]);
            }
          }}
          type="button"
        >
          <FiSend />
        </button>
      </div>
    </ConditionalWrapper>
  );
};

SendToApproveButton.propTypes = {
  line: LineToAPpprove.isRequired,
  selectedDate: PropTypes.string.isRequired,
  disabled: PropTypes.bool.isRequired,
  setChangeInLines: PropTypes.func.isRequired,
  changeInLines: PropTypes.bool.isRequired,
  setNewFetch: PropTypes.func.isRequired,
  newFetch: PropTypes.bool.isRequired
};

SendToApproveButton.defaultProps = {};

export default SendToApproveButton;
